<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <!-- グループ選択画面 -->
            <SelectTargetGroup v-if="showSelectTargetGroup"
                :tenantId="appData.tenantList[0].tenantId"
                :editingGroup="inputForm.targetGroup.value"
                @none="cancelSelectTargetGroup"
                @ok="setSelectTargetGroup"
                />

            <!-- ユーザー作成フォーム -->
            <div class="small-panel" v-show="!showSelectTargetGroup" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_buddycom_call_user'"></div>

                <hr class="dialog-hr" />
                <div class="dialog-body-small">
                    <el-form class="dialog-form-item" label-width="170px">
                        <!-- ユーザーID -->
                        <el-form-item ref="userName" prop="userName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userId'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_userId')">
                                    </div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                </el-tooltip>
                            </div>
                            <el-input id="userName" size="large" type="text"
                                :placeholder="$t('message.place_holder_input_text')"
                                v-model="inputForm.userName.value"
                                autocomplete="off"
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)"
                                clearable @clear="inputCheckAll()" />
                        </el-form-item>

                        <!-- ユーザー表示名 -->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userDisplayName'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left"
                                        v-html="$t('message.hint_user_display_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text"
                                :placeholder="$t('message.place_holder_input_text')"
                                v-model="inputForm.displayName.value"
                                autocomplete="off"
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)"
                                clearable @clear="inputCheckAll()" />
                        </el-form-item>

                        <!-- パスワード -->
                        <el-form-item ref="password" prop="password">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_password'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_password')">
                                    </div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                </el-tooltip>
                                <span style="position:relative">
                                    <button class="input-pass-check" type="button" @click="handleChangePasswordCheck()">
                                        {{ passwordShowHideButton }}
                                    </button>
                                </span>
                            </div>
                            <el-input id="password" size="large" :type="inputTypeOfPassword"
                                :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.password.value"
                                autocomplete="new-password"
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)"
                                @clear="inputCheckAll()" />
                        </el-form-item>

                        <!-- 通知先グループ -->
                        <el-form-item prop="targetGroups" ref="targetGroups">
                            <div slot="label" style="text-align:left;">
                                <span v-t="'message.item_bell_edit_label2'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left"
                                        v-html="$t('message.hint_buddycom_call_notify_group')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                </el-tooltip>
                            </div>
                            <el-button style="padding: 10px 20px" @click="openSelectTargetGroup">
                                <span v-t="'message.action_selection'"></span>
                            </el-button>
                            <span class="selected-target-group">{{ displayEditingTargetGroups }}</span>
                        </el-form-item>

                        <!-- 以下の関数 userOption がつく-->
                        <!-- タイムアウト時間 -->
                        <el-form-item style="text-align:right" ref="requestTimeOut"> <!-- res と　id 同じ値 -->
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_buddycomCall_request_time_out'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_buddycom_call_request_time_out'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="requestTimeOut" class="input-text-talkgroup" type="text"
                                :placeholder="$t('message.place_holder_input_text')"
                                v-model="userOptions.requestTimeOut.value"
                                @compositionstart.native="userOptionCompositionStart($event.target.id)"
                                @compositionend.native="userOptionCompositionEnd($event.target.id)"
                                @input.native="userOptionCheck($event.target.id)"
                                clearable @clear="inputCheckAll()"/>
                        </el-form-item>

                        <!-- 音声案内 on/off -->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_buddycomCall_idling_voice'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_buddycom_call_idling_text'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch
                                v-model="userOptions.idlingVoice.enabled"
                                active-color="#5171cb"
                                @change="handleOptionChange()">
                            </el-switch>
                        </el-form-item>

                        <!-- 音声案内 で話す内容のテキスト -->
                        <el-form-item v-if="userOptions.idlingVoice.enabled" ref="idlingVoice">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_buddycomCall_idling_voice_value'"></span>
                                    <span class="required" v-t="'message.item_required'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_buddycom_call_idling_text_value')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input
                                    class="idling-voice-input"
                                    id="idlingVoice"
                                    size="large"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 12 }"
                                    :maxlength="1000"
                                    show-word-limit
                                    :placeholder="$t('message.place_holder_input_text')"
                                    v-model="userOptions.idlingVoice.value"
                                    autocomplete="off"
                                    @compositionstart="userOptionCompositionStart('idlingVoice')"
                                    @compositionend="userOptionCompositionEnd('idlingVoice')"
                                    @input="userOptionCheck('idlingVoice')"
                                    clearable
                                    @clear="inputCheckAll()"
                                    />
                        </el-form-item>

                    </el-form>

                    <hr class="dialog-hr" />
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="addBuddycomCallUser" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '../common-validate.js'
import SelectTargetGroup from '../buddycomcall/BuddycomCallSelectTargetGroup.vue'

export default {
    components: {
        SelectTargetGroup,
    },
    props: {
        appData: Object,
    },
    data() {
        return {
            inputForm: {
                userName:       { validationRule: 'userId',             valid: false,   value: null,    isComposing: false },
                displayName:    { validationRule: 'reqDisplayName',     valid: false,   value: null,    isComposing: false },
                password:       { validationRule: 'password',           valid: false,   value: null,    isComposing: false },
                targetGroup:    { validationRule: 'required',           valid: false,   value: null,    isComposing: false }
            },
            userOptions: {
                requestTimeOut: { validationRule: 'buddycomCallRequestTimeout',                   valid: false,  value: null,    isComposing: false },
                idlingVoice:    { enabled: false,   validationRule: 'buddycomCallIdlingVoice',    valid: true,   value: null,    isComposing: false }
            },
            inputTypeOfPassword: 'password',
            passwordShowHideButton: 'SHOW',
            showSelectTargetGroup: false,
            disableButton: true,
        }
    },
    computed: {
        displayEditingTargetGroups() {
            const g = this.inputForm.targetGroup.value
            return g ? g.talkgroupName : ''
        }
    },
    methods: {
        // コールユーザーの作成
        addBuddycomCallUser: function() {
            this.$emit('add', { //　親view(User.vue) add イベントを発火
                name:                   this.$data.inputForm.userName.value,
                displayName:            this.$data.inputForm.displayName.value,
                password:               this.$data.inputForm.password.value,
                targetGroup:            this.$data.inputForm.targetGroup.value,
                requestTimeOut:         this.userOptions.requestTimeOut.value,
                idlingVoiceEnabled:     this.userOptions.idlingVoice.enabled,
                idlingText:             this.userOptions.idlingVoice.value
            });
        },

        setButtonStatus() {
            const isInputForm = !commonValidate.checkFormValidation(this.inputForm);
            const isUserOptions = !commonValidate.checkFormValidation(this.userOptions);
            // どちらかがエラーなら非表示
            this.disableButton = (isInputForm || isUserOptions);
        },

        // オプショントグル
        handleOptionChange() {
            if (this.userOptions.idlingVoice.enabled) {
                this.userOptions.idlingVoice.valid = false
                this.disableButton = true;
            } else {
                this.userOptions.idlingVoice.valid = true
                this.disableButton = false;
            }
            this.setButtonStatus()
        },

        handleChangePasswordCheck() {
            this.inputTypeOfPassword =
            this.inputTypeOfPassword === 'password' ? 'text' : 'password';
        },

        // 必須入力の値確認
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) return;

            const result = commonValidate.validateItem(
                this.$i18n,
                this.inputForm[eventTargetId].validationRule,
                this.inputForm[eventTargetId].value
            );

            if (result.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId]?.clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = 'error';
                this.$refs[eventTargetId].validateMessage = result.message;
            }

            this.setButtonStatus();
        },

        // オプション入力の値確認
        userOptionCheck(eventTargetId) {
            if (this.userOptions[eventTargetId].isComposing) return;

            // 入力内容の確認
            const result = commonValidate.validateItem(
                this.$i18n,
                this.userOptions[eventTargetId].validationRule,
                this.userOptions[eventTargetId].value
            );

            if (result.valid) {
                this.userOptions[eventTargetId].valid = true;
                this.$refs[eventTargetId]?.clearValidate();
            } else {
                // エラー表示
                this.userOptions[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = 'error';
                this.$refs[eventTargetId].validateMessage = result.message;
            }

            this.setButtonStatus();
        },

        // 全入力フォーム確認
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
            for (let targetId in this.userOptions) {
                this.userOptionCheck(targetId);
            }
        },

        // 必須入力用
        compositionStart(id) {
            this.inputForm[id].isComposing = true;
        },
        compositionEnd(id) {
            this.inputForm[id].isComposing = false
            this.inputCheck(id)
        },

        // オプション用
        userOptionCompositionStart(id) {
            this.userOptions[id].isComposing = true;
        },
        userOptionCompositionEnd(id) {
            this.userOptions[id].isComposing = false
            this.userOptionCheck(id)
        },

        openSelectTargetGroup() {
            this.showSelectTargetGroup = true;
        },
        cancelSelectTargetGroup() {
            this.showSelectTargetGroup = false;
        },
        setSelectTargetGroup(talkGroup) {
            this.inputForm.targetGroup.value = talkGroup
            this.inputForm.targetGroup.valid = !!talkGroup
            this.setButtonStatus()
            this.cancelSelectTargetGroup()
        },
    },
    watch: {
        inputTypeOfPassword(newVal) {
            this.passwordShowHideButton = newVal === 'password' ? 'SHOW' : 'HIDE';
        },
    },
}
</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 270px;
    top: 2px;
    font-size: 10px;
    z-index: 10;
    color: #848991;
}

/* scoped の場合は :deep() を付ける */
.idling-voice-input :deep(.el-textarea__inner) {
  padding-right: 80px;   /* 右側にカウンター分の余白 */
  padding-bottom: 12px;  /* 下にも少し余白 */
}

.idling-voice-input :deep(.el-input__count) {
  right: 18px;  /* デフォルトより左にずらす */
  bottom: 4px;           /* 位置が気になれば微調整 */
}
.selected-target-group {
    display: inline-block;
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
}

</style>
